.editor-root {
  font-family: var(--mantine-font-family);
}

.editor-root.compact {
  font-size: var(--mantine-font-size-xs);
}

.editor-paragraph {
  margin: 0;
  margin-bottom: 8px;
}

.editor-paragraph:last-child {
  margin-bottom: 0;
}

.editor-text-bold {
  font-weight: bold;
}

.editor-text-italic {
  font-style: italic;
}

.editor-text-underline {
  text-decoration: underline;
}

.editor-text-strikethrough {
  text-decoration: line-through;
}

.editor-text-code {
  background-color: var(--mantine-color-gray-1);
  color: var(--mantine-color-gray-8);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 0.9em;
}

.editor-heading-h1 {
  font-size: 2em;
  font-weight: bold;
  margin: 20px 0 10px 0;
}

.compact .editor-heading-h1 {
  font-size: 1.3em;
}

.editor-heading-h2 {
  font-size: 1.5em;
  font-weight: bold;
  margin: 16px 0 8px 0;
}

.compact .editor-heading-h2 {
  font-size: 1.15em;
}

.editor-heading-h3 {
  font-size: 1.25em;
  font-weight: bold;
  margin: 14px 0 7px 0;
}

.compact .editor-heading-h3 {
  font-size: 1.1em;
}

.editor-heading-h4 {
  font-size: 1.1em;
  font-weight: bold;
  margin: 12px 0 6px 0;
}

.compact .editor-heading-h4 {
  font-size: 1em;
}

.editor-heading-h5 {
  font-size: 1em;
  font-weight: bold;
  margin: 10px 0 5px 0;
}

.compact .editor-heading-h5 {
  font-size: 1em;
}

.editor-heading-h6 {
  font-size: 0.9em;
  font-weight: bold;
  margin: 8px 0 4px 0;
}

.compact .editor-heading-h6 {
  font-size: 0.9em;
}

.editor-quote {
  margin: 0 0 10px 0;
  padding-left: 16px;
  border-left: 4px solid var(--mantine-color-gray-4);
  font-style: italic;
  color: var(--mantine-color-gray-7);
}

.editor-list-ol,
.editor-list-ul {
  padding: 0;
  margin: 0 0 10px 20px;
}

.editor-listitem {
  margin: 2px 0;
}

.editor-nested-listitem {
  list-style-type: none;
}

.editor-listitem:has(> [data-suggestion-source='deletion']:only-child) {
  list-style-type: none;
}

.editor-code {
  background-color: var(--mantine-color-gray-0);
  color: var(--mantine-color-gray-8);
  font-family: 'Monaco', 'Courier New', monospace;
  display: block;
  padding: 8px 12px;
  border-radius: 4px;
  margin: 8px 0;
  overflow-x: auto;
  font-size: 0.8em;
  line-height: 1.4;
}

.editor-link {
  color: var(--mantine-color-blue-6);
  text-decoration: underline;
  cursor: pointer;
}

.editor-link:hover {
  color: var(--mantine-color-blue-7);
  text-decoration: underline;
}

.editor-link:visited {
  color: var(--mantine-color-violet-6);
}

.editor-table-scroll-wrapper {
  overflow-x: auto;
  margin: 12px 0;
  background-image:
    linear-gradient(to right, var(--table-scroll-mask, var(--mantine-color-body)) 30%, transparent),
    linear-gradient(to left, var(--table-scroll-mask, var(--mantine-color-body)) 30%, transparent),
    linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent),
    linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  background-position:
    left center,
    right center,
    left center,
    right center;
  background-size:
    40px 100%,
    40px 100%,
    16px 100%,
    16px 100%;
  background-attachment: local, local, scroll, scroll;
  background-repeat: no-repeat;
}

.editor-table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
}

.editor-table-cell {
  border: 1px solid var(--mantine-color-gray-4);
  padding: 8px 12px;
  vertical-align: top;
  text-align: left;
  position: relative;
  min-width: 12em;
  overflow-wrap: break-word;
}

.editor-table-cell-header {
  border: 1px solid var(--mantine-color-gray-4);
  padding: 8px 12px;
  vertical-align: top;
  text-align: left;
  background-color: var(--mantine-color-gray-0);
  color: var(--mantine-color-gray-8);
  font-weight: 600;
  position: relative;
  min-width: 12em;
  overflow-wrap: break-word;
}

[data-suggestion] .editor-table-cell-header {
  background-color: inherit;
}

.editor-table-add-rows,
.editor-table-add-columns {
  position: absolute;
  background-color: var(--mantine-color-gray-2);
  border: 0;
  cursor: pointer;
  animation: table-controls 0.2s ease;
}

.editor-table-add-rows:hover,
.editor-table-add-columns:hover {
  background-color: var(--mantine-color-gray-3);
}

.editor-table-add-rows::after,
.editor-table-add-columns::after {
  content: '+';
  color: var(--mantine-color-gray-6);
  font-size: 1em;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

@keyframes table-controls {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.editor-table-selection {
  user-select: none;
  -webkit-user-select: none;
  caret-color: transparent;
}

.editor-table-selection ::selection {
  background: transparent;
}

.editor-table-cell-selected {
  background-color: highlight;
}

::highlight(editor-preserved-selection) {
  background-color: Highlight;
  color: HighlightText;
}
